import { requestApi } from "../../../../../../utils/requestApi";
import { POST } from "../../../../../../types/httpMethod";

export type QrFormType = {
  readonly size: string;
  readonly style: QrStylesEnum;
  readonly color: string;
  readonly logoUrl?: string;
  readonly fileType: FileTypesEnum;
  readonly description?: string;
};

export enum QrStylesEnum {
  STANDARD = "standard",
  ROUNDED = "rounded",
  DOTS = "dots",
}

export enum FileTypesEnum {
  PNG = "png",
  JPEG = "jpeg",
}

export const getSurveyInstanceUrl = (surveyId: string, receiver: string, receiverType: any) => {
  return window._env_.WEB_SURVEY_BASE_URL.concat("/", surveyId, "?receiver=", receiver, "&channel=", receiverType);
};

export const getShortUrl = async (surveyId: string, receiver: string, receiverType: any): Promise<string> => {
  const fullUrl = `${window._env_.WEB_SURVEY_BASE_URL}/${surveyId}?receiver=${receiver}&channel=${receiverType}`;

  const requestBody = {
    target: fullUrl,
    expireAt: undefined,
  };

  return await requestApi(
    POST,
    `${window._env_.API_BASE_URL + window._env_.API_PATH}/short-url/v1?checkIfExist=true`,
    requestBody,
  );
};
